{
  "settings": {
    "title": "Kontoeinstellungen",
    "subtitle": "Verwalte deine E-Mail-Adresse, dein Passwort und deinen Kontostatus.",
    "needHelp": "Brauchst du Hilfe? Tritt unserem Discord bei"
  },
  "changeEmail": {
    "title": "E-Mail-Adresse ändern",
    "subtitle": "Wenn du deine E-Mail-Adresse änderst, musst du deine neue E-Mail-Adresse erneut bestätigen. Du wirst aus allen Sitzungen abgemeldet.",
    "newEmailLabel": "Neue E-Mail-Adresse",
    "newEmailPlaceholder": "Neue E-Mail eingeben",
    "currentPasswordLabel": "Aktuelles Passwort",
    "currentPasswordPlaceholder": "Aktuelles Passwort eingeben",
    "submitButton": "E-Mail-Adresse aktualisieren",
    "submittingButton": "Wird aktualisiert..."
  },
  "changePassword": {
    "title": "Passwort ändern",
    "subtitle": "Aktualisiere dein Passwort. Du bleibst auf diesem Gerät angemeldet.",
    "currentPasswordLabel": "Aktuelles Passwort",
    "currentPasswordPlaceholder": "Aktuelles Passwort eingeben",
    "newPasswordLabel": "Neues Passwort",
    "newPasswordPlaceholder": "Neues Passwort eingeben",
    "confirmPasswordLabel": "Neues Passwort bestätigen",
    "confirmPasswordPlaceholder": "Neues Passwort bestätigen",
    "submitButton": "Passwort ändern",
    "submittingButton": "Wird aktualisiert..."
  },
  "closeAccount": {
    "title": "Konto schliessen",
    "subtitle": "Deaktiviere dein Konto dauerhaft. Falls du ein aktives Abonnement hast, wird es gekündigt. Diese Aktion kann nicht wieder rückgängig gemacht werden.",
    "openButton": "Ich möchte mein Konto schliessen",
    "warning": "⚠️ Warnung: Dadurch wird dein Konto deaktiviert, alle aktiven Abonnements werden gekündigt, du wirst aus allen Sitzungen abgemeldet und für gekündigte Abonnements erfolgt keine Rückerstattung. Deine Daten bleiben erhalten, aber dein Konto wird unzugänglich.",
    "passwordLabel": "Dein Passwort",
    "passwordPlaceholder": "Gib dein Passwort ein",
    "confirmLabel": "Tippe",
    "confirmCode": "KONTO SCHLIESSEN",
    "confirmLabelEnd": "zur Bestätigung",
    "confirmPlaceholder": "KONTO SCHLIESSEN",
    "cancelButton": "Abbrechen",
    "submitButton": "Konto dauerhaft schliessen",
    "submittingButton": "Wird geschlossen..."
  },
  "contactUs": {
    "title": "Kontaktiere uns",
    "body": "Kontaktiere uns unter",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "oder tritt bei Fragen unserer Discord-Community bei."
  }
}
